<template>
  <v-lazy><div class="section fade-in">
    <v-container fluid>
        
      <v-row justify="center">
        <v-col cols="0" md="3">
          
            
        </v-col>
        <v-col cols="12" md="6">
            <v-row cols="12" justify="center" class="mb-8">
                <v-col cols="12" class="text-center">
                    <h2 class="section__header-title text-h3 font-weight-bold">Chat Inbox
                    </h2>
                    <h2 class="text-subtitle-1">All of your digital mediums in a single screen</h2>
                </v-col>
                
            </v-row>
            <v-row>
                <v-sheet class="mb-8 left-message bg-primary rounded-lg px-5 py-2" color="#d7dae1">
                    Move seamlessly between SMS, MMS, Email, Web and Voice channels.
                </v-sheet>
            </v-row>
            <v-row justify="end">
                <v-sheet class="mb-8 right-message bg-primary rounded-lg px-5 py-2  white--text" color="#1582d8">
                    Power routing rules let you pick out <b>premium payers</b> from inbound message queues.
                </v-sheet>
            </v-row>
            <v-row>
                <v-sheet class="mb-8 left-message bg-primary rounded-lg px-5 py-2" color="#d7dae1">
                    Fine tuned <b>message classification</b> engines pick up on key issues and guide customers directly to specialised groups like <b>Hardship and PAM</b> teams.
                </v-sheet>
            </v-row>
            <v-row justify="end">
                <v-sheet class="mb-8 right-message bg-primary rounded-lg px-5 py-2  white--text" color="#1582d8">
                    Direct integrations with your host systems provides live data.
                </v-sheet>
            </v-row>
            <v-row>
                <v-sheet class="mb-8 left-message bg-primary rounded-lg px-5 py-2 " color="#d7dae1">
                    Embeddable in your CRM to keep your team on a single screen.
                </v-sheet>
            </v-row>
            
         
        </v-col>
        <v-col cols="0" md="3">
          
         
        </v-col>
      </v-row>
    </v-container>
  </div></v-lazy>
</template>
<script>
export default {
    name: 'CollectionsEngagement',
}
</script>

<style lang="scss">
.left-message, .right-message {
    width: 50%;
    position: relative;
}
.left-message::after, .right-message::after {
    content: '';
    position: absolute;
    
    border: 12px solid;
    
}

.left-message::after {
    left: -11px;
    top: 0;
    border-color: #d7dae1 transparent transparent transparent;
}

.right-message::after {
    right: -11px;
    top: 0;
    border-color: #1582d8 transparent transparent transparent;
}


</style>